import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[appRoleNameTranslation]',
    standalone: false
})
export class RoleNameTranslationDirective implements OnDestroy {

  private _roleName!: string;

  @Input({ required: true }) set appRoleNameTranslation(roleName: string) {
    this._roleName = roleName;
    this.getTranslation();
  }

  get appRoleNameTranslation(): string {
    return this._roleName;
  }

  private translationSub: Subscription = new Subscription();

  constructor(private el: ElementRef,
              private translateService: TranslateService) { }

  ngOnDestroy() {
    this.translationSub.unsubscribe();
  }

  private getTranslation() {
    this.translationSub.unsubscribe();
    let translationKey = 'admin.roles.' + this._roleName;
    this.translationSub = this.translateService.get(translationKey).subscribe(roleTranslation => {
      this.el.nativeElement.innerText = roleTranslation != translationKey
        ? roleTranslation
        : this._roleName;
    });
  }
}
